var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "d-flex justify-content-around h-100 w-100 mobile-nav-item-container",
    },
    [
      _c("div", { staticClass: "mobile-nav-item" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm._f("trans")("Stage")))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mobile-nav-item" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm._f("trans")("Tools")))]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mobile-nav-icon" }, [
      _c("i", { staticClass: "far fa-list fa-2x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mobile-nav-icon" }, [
      _c("i", { staticClass: "far fa-list fa-2x" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }